module.exports = __webpack_public_path__ + "static/media/martlet-text.0ef3ce29.svg";